import * as _ from 'lodash';
import { FilterBadge } from '../filter-badge/FilterBadge';
import React from 'react';
import { getFilterLabel } from '../models/filters';
import './FilterBadgeContainer.scss';

export const FilterBadgeContainer = ({
    filters,
    TypeLabelPipe,
    removeFilter
}) => {
    return (
        filters && (
            <div className={'filter-badges'}>
                {_.map(filters, (value, key) => {
                    const label = getFilterLabel(key, value, TypeLabelPipe);

                    return (
                        label && (
                            <FilterBadge
                                key={label}
                                filterValue={value}
                                filterLabel={label}
                                removeFilter={removeFilter}
                            />
                        )
                    );
                })}
            </div>
        )
    );
};
